import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomModal from '../../../../shared/CustomModal/CustomModal';
import CustomCard from '../../../../shared/CustomCard/CustomCard';
import CustomButton from '../../../../shared/CustomButton/CustomButton';
import zeplinColor from '../../../../../theme/Color';

interface DeleteIntegrationModalProps {
  open: boolean;
  integrationName: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteIntegrationModal: React.FC<DeleteIntegrationModalProps> = ({
  open,
  integrationName,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <CustomModal handleClose={onCancel} open={open}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: { xs: '20px', xl: '24px' },
            backgroundColor: zeplinColor.Neutral1,
            width: '375px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
              Delete Integration?
            </Typography>
            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              Deleting “{integrationName}” will remove all API credentials and stop all related data
              sync and workflows. This action cannot be undone. Are you sure you want to delete?
            </Typography>
            <Box
              sx={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}
            >
              <CustomButton
                disabled={loading}
                onClick={onCancel}
                variant='outlined'
                color='primary'
                style={{
                  borderRadius: '8px',
                  height: '40px',
                  padding: '8px 16px',
                  flex: 1,
                  border: `1px solid ${zeplinColor.BasicBlack}`,
                  '&.hover': {
                    backgroundColor: zeplinColor.Neutral3,
                  },
                }}
                textStyle={{ color: zeplinColor.BasicBlack }}
                text='Cancel'
              />
              <CustomButton
                disabled={loading}
                onClick={onConfirm}
                variant='contained'
                color='primary'
                style={{
                  borderRadius: '8px',
                  height: '40px',
                  padding: '8px 16px',
                  backgroundColor: loading ? zeplinColor.Neutral3 : zeplinColor.Error,
                  width: 'fit-content',
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={loading ? 'Deleting...' : 'Delete Integration'}
              />
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default DeleteIntegrationModal;
